import React, { Component } from 'react';

import { TableLayout } from '../Menu/Stock/containers/Layout';

import { isEmpty } from "lodash"
import { Box, Button, Table, TableBody, TableRow, TableCell, TableHead } from '@material-ui/core';
import PageAdmin from './Layouts/PageAdmin';

class CreditAccount extends Component {
    state = { 
     }
    componentDidMount() {
        this.props.fetchCredit()  
        this.props.fetchCreditList()  
    }
    render() {
        const { CREDIT, TRANSACTION_LIST } = this.props;
        return (
            <PageAdmin title="Porte-Feuille">
                <Box p={2}>
                    <Button variant="contained" color="secondary">Créditer Votre compte</Button>
                </Box>
                {/* <h3>Porte-Feuille</h3> */}
                
                <Table className="table">
                    <TableBody>
                        <TableRow>
                            <TableCell>Solde {CREDIT.creditCurrency}</TableCell>
                            <TableCell>{CREDIT.creditAmount}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Solde SMS</TableCell>
                            <TableCell>{CREDIT.creditSMS}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <hr/>
                <h4>Listes des transactions</h4>
                <TableLayout >
                {/* height={"690px"} */}
                    <TableHead>
                        <TableRow>
                            <TableCell component="th">Date</TableCell>
                            <TableCell component="th">Nom</TableCell>
                            <TableCell component="th">Montant</TableCell>
                            <TableCell component="th">Options</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isEmpty(TRANSACTION_LIST) &&
                            TRANSACTION_LIST.map( trans => (
                                <TableRow>
                                    <TableCell>{new Date(trans.date).toLocaleDateString('fr-FR')}</TableCell>
                                    <TableCell>{trans.name}</TableCell>
                                    <TableCell>{trans.amount}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </TableLayout>
            </PageAdmin>

        );
    }
}


export default CreditAccount